
import View from './option-list-view';
import OptionListGenerator from './option-list-generator';

export default OptionListGenerator(View);


// WEBPACK FOOTER //
// ./js/orderview/option-list.js